module.exports = __webpack_public_path__ + "static/media/trash.ece1e70d.svg";